module.exports = __webpack_public_path__ + "static/img/bg2.2e086bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/bg2.png
// module id = gY5o
// module chunks = 70